<template>
    <div>
      <StatusBasedCases :selectedStatuses="statuses" :selectedSubStatuses="subStatuses"></StatusBasedCases>
    </div>
  </template>

  <script>
  const StatusBasedCases = defineAsyncComponent(() =>
    import("@/components/cases/StatusBasedBilledCases")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
        StatusBasedCases,
    },
    data() {
    return {
      statuses: "Self Pay Reviewed",
      subStatuses: "Self Pay Reviewed",
    };
  },
  };
  </script>